import {Component, output} from '@angular/core';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {debounceTime} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatInput} from '@angular/material/input';

@Component({
  selector: 'tgrid-text-filter',
  imports: [
    MatFormField,
    MatLabel,
    ReactiveFormsModule,
    MatInput,
  ],
  templateUrl: './text-filter.component.html',
  styleUrl: './text-filter.component.scss',
  standalone: true,
})
export class TextFilterComponent {
  filterChange = output<string>();

  protected filterControl: FormControl = new FormControl<string>('');

  constructor() {


    this.filterControl.valueChanges.pipe(
      debounceTime(100),
      takeUntilDestroyed(),
    ).subscribe(newValue => {
      this.filterChange.emit(newValue);
    });
  }

}
